import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CompanyCalendarFeatureComponent } from './company-calendar-feature/company-calendar-feature.component';
const log = new LoggingService();

export const CompanyCalendarRoute: Ng2StateDeclaration = {
    name: 'companydates',
    url: '/companydates',
    data: { requiresAuth: true },

    component: CompanyCalendarFeatureComponent
};
